import { CollectionEmailTemplate } from '../config/model';

export type CollectionEmailSendStatus = 'queued' | 'sent' | 'failed';
export type CollectionEmailSendSource = 'automatic' | 'manual';

export interface CollectionEmailSendListItem {
  id: number;
  company: string;
  bill_code: string;
  location: string;
  tone: CollectionEmailTemplate['tone'];
  status: CollectionEmailSendStatus;
  send_source: CollectionEmailSendSource;
  to_emails: string[];
  delivered_at: string | null;
  triggered_by_name: string | null;
}

export interface CollectionEmailSendDetail extends CollectionEmailSendListItem {
  subject: string;
  queued_at: string | null;
  body: string;
  reply_to_email: string;
  sender_display_name: string;
  attachment_metadata: { edoc_invoice_import_id: number; filename: string }[];
  error_message: string | null;
}

export interface CollectionEmailSendsResponse {
  total_records: number;
  page: number;
  per_page: number;
  result: CollectionEmailSendListItem[];
}

export const STATUS_LABELS: Record<CollectionEmailSendStatus, string> = {
  queued: 'Queued',
  sent: 'Sent',
  failed: 'Failed',
};

export const SOURCE_LABELS: Record<CollectionEmailSendSource, string> = {
  automatic: 'Automatic',
  manual: 'Manual',
};
